import React, { useEffect, useState } from 'react'
import PrivateLayout from '../../../layouts/PrivateLayout/PrivateLayout'
import DashboardPagesTemplate from '../../../components/DashboardPagesTemplate/DashboardPagesTemplate'
import { Dropdown } from 'flowbite-react'
import { numberWithCommas } from '../../../utils/formatNumber'
import moment, { Moment } from 'moment'
import StatusView from '../../../components/StatusView/StatusView'
import { BalanceHistoryData, ColumnBalanceHistory } from '../../../types/TablesTypes/balanceHistory'
import showToast from '../../../components/CustomToast/toastHelper'
import client from '../../../api/client'
import { useCurrency } from '../../../contexts/CurrencyContext'
import { FaEllipsisH } from 'react-icons/fa'
import { BillsPaymentHistoryData, ColumnBillsPayment } from '../../../types/TablesTypes/billsPaymentHistory'
import CustomModal from '../../../components/Modal/CustomModal'
import PaymentSummaryModal from '../PaymentSummaryModal/PaymentSummaryModal'

const BillsPaymentRecords = () => {
  const {currency} = useCurrency()
  const [filters, setFilters] = useState({
      fromDate: "",
      toDate: "",
      currency: currency ,
      status: "",
      billCategory:""
  });

  const [bearer, setBearer] = useState<boolean>(false);
  const [history, setHistory] = useState<any>(null);
  const [tableRow, setTableRow] = useState<BillsPaymentHistoryData[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [loading, setLoading] = useState<boolean>(true);
  const [isExport, setIsExport] = useState<boolean>(false)
  const [isExportReady, setIsExportReady] = useState<boolean>(false); 
  const [isExportLoading, setIsExportLoading] = useState<boolean>(false);
  const [openDetailsModal, setOpenDetailsModal] = useState<boolean>(false)
  const [paymentId, setPaymentId] = useState<number>(1)

  const clickExport = async () => {
      setIsExport(true);
      setIsExportLoading(true)
      await fetchHistory(); 
  
      if (history && history.items?.length > 0) {
          setIsExportReady(true); 
      }
  
      setIsExportLoading(false); 
  };


  useEffect(() => {
      const fetchData = async () => {
          setLoading(true)
          await fetchHistory();
          setLoading(false)
      };
      fetchData();
  }, [filters]);

  const fetchHistory = async () => {
      try {
          const mappedFilters = {
              ...filters,
          };
          const apiUrl = '/subsidiary/dashboard/bills-payment/get';
          const params = new URLSearchParams(
              mappedFilters
          ).toString();
          const response = await client.get(`${apiUrl}?${params}`);
          console.log(response);
          
          setHistory(response.data.data);
          setTotalPages(response.data.data.page.totalPage);
      } catch (err: any) {
          if (err?.response?.data?.message === 'Please login again') {
              sessionStorage.clear();
              window.location.href = '/';
          } else {
              const message = err?.response?.data?.message;
              console.error('Error getting data', err);
              showToast(message, "error");
          }
      }
  };

//   useEffect(() => {
//       setFilters((prevFilters) => ({
//           ...prevFilters,
//           currency: currency,
//       }));
//   }, [currency]);

  const handleViewDetails =(paymentId:number)=>{
    setOpenDetailsModal(true)
    setPaymentId(paymentId)
  }


  const dataHistory = () => {
      const tempArr: BillsPaymentHistoryData[] = [];
      history?.items
          ?.slice(0)
          .forEach((balance: any, index: number) => {
              tempArr.push({
                  date: (moment.utc(balance?.dateCreated).local() as Moment).format('MMMM Do YYYY, h:mm a'),
                  amount: `${balance.currency} ${numberWithCommas(balance?.amount)}`,
                  fee:`${balance.currency} ${numberWithCommas(balance?.fee)}`,
                  transactionreference: balance.transactionReference,
                  merchantRef:balance?.merchantReference,
                  billerCode:balance.billerCode,
                  packageCode:balance.itemCode,
                  status: (
                    <StatusView
                        status={balance?.status}
                        green='Successful'
                        red='Failed'
                        indigo="Pending"
                    />
                ),
                  action: (
                      <Dropdown label={<FaEllipsisH />} inline arrowIcon={false} placement='right-start'>
                            <Dropdown.Item onClick={()=> handleViewDetails(balance.id)}>View Details</Dropdown.Item>
                      </Dropdown>
                  ),
              });
          });
      return tempArr;
  };

  useEffect(()=>{
      setTableRow(dataHistory());

  },[history?.items])

  return (
    <div>
            <DashboardPagesTemplate
                title='Bills Payment History'
                onFilterChange={setFilters}
                dataToExport={isExportReady ? history?.items : []}
                apiUrl=''
                ctaButtonExists={false}
                exportButtonExists={true}
                dropdownItems={["All","Successful","Failed","Initiated", "Pending"]}
                data={tableRow}
                showSearch={true}
                buttonIcon=''
                buttonLabel=''
                headings={ColumnBillsPayment}
                filters={filters}
                emptyMessage={`You currently do not have any balance history in ${currency}`}
                statusKey='status'
                loading={loading}
                clickExportButton={clickExport}
                exportButtonLoading={isExportLoading}
                exportButtonClicked={isExport}
            />
            <CustomModal dismissible show={openDetailsModal} icon='' onClose={() => setOpenDetailsModal(false)} size='md' children={
                <PaymentSummaryModal billPaymentId={paymentId} onclose={() => setOpenDetailsModal(false)}/>
            } />
        </div>
  )
}

export default BillsPaymentRecords
